// src/components/popups/MentionDrawer.js
import React from 'react';
import './MentionDrawer.css';
import placeholderProfile from '../../assets/placeholder-profile.png';
import placeholderLogo from '../../assets/placeholder-logo.png';
import storeIcon from '../../assets/mystore-icon.png';
import userIcon from '../../assets/User-icon.png';

function MentionDrawer({ results, onSelect }) {
  if (!results || results.length === 0) return null;

  const getAvatar = (item) => {
    if (item.type === 'store') {
      const value = item.businessLogo;
      console.log('🧩 STORE:', item.username, '| businessLogo:', value);

      if (
        !value ||
        value.trim() === '' ||
        value === 'undefined' ||
        value === null ||
        value.includes('/uploads/store-logos/placeholder.png')
      ) {
        console.log(`🔗 Using local placeholderLogo for store: ${item.username}`);
        return placeholderLogo;
      } else {
        console.log(`✅ Using actual businessLogo: ${value}`);
        return value;
      }
    } else {
      const value = item.profilePic;
      console.log('🧩 USER:', item.username, '| profilePic:', value);

      if (
        !value ||
        value.trim() === '' ||
        value === 'undefined' ||
        value === null
      ) {
        console.log(`🔗 Using local placeholderProfile for user: ${item.username}`);
        return placeholderProfile;
      } else {
        console.log(`✅ Using actual profilePic: ${value}`);
        return value;
      }
    }
  };

  return (
    <div className="mention-drawer">
      {results.map((item, index) => {
        const isStore = item.type === 'store';
        const displayName = item.name || item.username;
        const username = item.username;

        console.log('🗂️ Mention result item:', item);

        const avatar = getAvatar(item);

        console.log('📷 Final avatar src:', avatar);

        return (
          <div
            className="mention-suggestion"
            key={index}
            onClick={() => {
              const selectedMention = {
                username: username,
                name: displayName,
                type: isStore ? 'store' : 'user',
              };

              console.log('✅ Mention selected:', selectedMention);
              onSelect(selectedMention);
            }}
          >
            <img
              src={avatar}
              alt="avatar"
              className="mention-avatar"
            />
            <div className="mention-info">
              <div className="mention-title-line">
                <strong>{displayName}</strong>
                <img
                  src={isStore ? storeIcon : userIcon}
                  alt="type"
                  className="mention-icon"
                />
              </div>
              <div className="mention-type">@{username}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default MentionDrawer;
